import { render, staticRenderFns } from "./AttachmentViewer.vue?vue&type=template&id=ade53b4c&scoped=true"
import script from "./AttachmentViewer.vue?vue&type=script&lang=js"
export * from "./AttachmentViewer.vue?vue&type=script&lang=js"
import style0 from "./AttachmentViewer.vue?vue&type=style&index=0&id=ade53b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade53b4c",
  null
  
)

export default component.exports